export default __webpack_public_path__ + "static/media/22.eba03f2f.png";